<form [formGroup]="form()">
    <div class="grid grid-cols-1 gap-4 mb-4">
        
        <spike-field-select 
            label="Wallet di Origine" 
            [initialValue]="walletStoreService.findReactive(form().controls['finWalletIdFrom'].value)()" 
            formControlName="finWalletIdFrom" 
            selectKey="finWalletId" 
            selectValue="shortDescription" 
            listTitle="Seleziona Wallet di Origine" 
            detailTitle="Dettaglio wallet origine">
            <ng-template #list>
                <spike-wallet-list #listRef [list]="walletStoreService.getList()()"/>
            </ng-template>
        </spike-field-select>

        <spike-field-select 
            label="Wallet di Destinazione" 
            [initialValue]="walletStoreService.findReactive(form().controls['finWalletIdTo'].value)()" 
            formControlName="finWalletIdTo" 
            selectKey="finWalletId" 
            selectValue="shortDescription" 
            listTitle="Seleziona Wallet di Destinazione" 
            detailTitle="Dettaglio wallet destinazione">
            <ng-template #list>
                <spike-wallet-list #listRef [list]="walletStoreService.getList()()"/>
            </ng-template>
        </spike-field-select>

        <spike-field-number 
            formControlName="amount" 
            label="Importo Trasferimento"
            mode="currency" 
            currency="EUR" 
            placeholder="0.00">
        </spike-field-number>

        <spike-field-date 
            formControlName="accountingDate" 
            label="Data Trasferimento" 
            placeholder="Seleziona data">
        </spike-field-date>

        <spike-field-text-area 
            formControlName="description" 
            label="Note Giroconto" 
            placeholder="Dettagli aggiuntivi sul trasferimento...">
        </spike-field-text-area>

    </div>
</form>